import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbackCondition,
} from '../types';
import {
  ADMIN_POSTBACKS_CONDITION_SAVE_URL,
  AFFILIATE_POSTBACKS_CONDITION_SAVE_URL,
  POSTBACKS_SAVE_CONDITION_MUTATION_KEY,
} from '../constants';

export default function usePostbackConditionRemoveMutation(): IContextMutationResult<
  void,
  Error,
  IPostbackCondition
> {
  const { fetchDelete } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<void, Error, IPostbackCondition>({
    mutationKey: [POSTBACKS_SAVE_CONDITION_MUTATION_KEY],
    mutationFn: ({
      affiliateId,
      postbackId,
      ...condition
    }) => (
      fetchDelete<void>(
        isAdminNamespace.value ? ADMIN_POSTBACKS_CONDITION_SAVE_URL : AFFILIATE_POSTBACKS_CONDITION_SAVE_URL,
        {
          permission: POSTBACKS_PERMISSIONS.SHOW,
          urlParams: {
            id: affiliateId,
            postbackId,
            conditionId: condition.id,
          },
        },
      )
    ),
  });
}
